/*eslint react/no-string-refs: "off" */
import React from 'react';

import message from './message';
import Icon from 'components/Icon';
import { socialNetworkIdPattern } from 'store/entity/patterns';

class SocialNetwork extends React.Component {
  static checkURL(event) {
    const target = event.target || event.srcElement;
    let value = target.value;
    if (value.indexOf('http') !== -1) {
      value = 'http://' + value;
    }
    target.value = value;
    return target;
  }
  render() {
    const { provider } = this.props;
    return (
      <div className="section">
        <div className="row ">
          <div className="input-field col m6 s12">
            <Icon type={'globe'} />
            <input
              id="site"
              ref="website"
              type="url"
              className="validate"
              defaultValue={provider.publicProperties?.website}
            />
            <label htmlFor="site" data-error={message.enterSiteUrl}>
              {message.website}
            </label>
          </div>
          <div className="input-field col m6 s12">
            <Icon type={'mail'} />
            <input
              id="email"
              ref="email"
              type="email"
              className="validate"
              defaultValue={provider.publicProperties?.email}
            />
            <label htmlFor="email" data-error={message.enterEmailUrl}>
              {message.email}
            </label>
          </div>
        </div>
        <div className="row">
          <div className="input-field col m6 s12">
            <Icon type={'send'} />
            <input
              id="telegram_chanel"
              ref="telegramChanel"
              type="text"
              className="validate"
              pattern={socialNetworkIdPattern}
              defaultValue={provider.publicProperties?.telegramChanel}
            />
            <label
              htmlFor="telegram_chanel"
              data-error={message.enterTelegramId}
            >
              {message.telegram_chanel}
            </label>
          </div>
          <div className="input-field col m6 s12">
            <Icon type={'send'} />
            <input
              id="telegram_user"
              ref="telegramId"
              type="text"
              className="validate"
              defaultValue={provider.publicProperties?.telegramId}
            />
            <label htmlFor="telegram_user" data-error={message.enterTelegramId}>
              {message.telegram_user}
            </label>
          </div>
        </div>
        <div className="row">
          <div className="input-field col m6 s12">
            <Icon type={'instagram'} />
            <input
              id="instagram"
              ref="instagramId"
              type="text"
              className="validate"
              pattern={socialNetworkIdPattern}
              defaultValue={provider.publicProperties?.instagramId}
            />
            <label htmlFor="instagram" data-error={message.enterInstagramUrl}>
              {message.instagram}
            </label>
          </div>
          <div className="input-field col m6 s12">
            <Icon type={'youtube'} />
            <input
              id="aparat"
              ref="aparat"
              type="url"
              className="validate"
              defaultValue={provider.publicProperties?.aparat}
            />
            <label htmlFor="aparat" data-error={message.enterAparatUrl}>
              {message.aparat}
            </label>
          </div>
        </div>
        <div className="row">
          <div className="input-field col m6 s12">
            <Icon type={'facebook'} />
            <input
              id="facebook"
              ref="facebook"
              type="url"
              className="validate"
              defaultValue={provider.publicProperties?.facebook}
            />
            <label htmlFor="facebook" data-error={message.enterFacebookUrl}>
              {message.facebook}
            </label>
          </div>
          <div className="input-field col m6 s12">
            <Icon type={'linkedin'} />
            <input
              id="linkedIn"
              ref="linkedIn"
              type="url"
              className="validate"
              defaultValue={provider.publicProperties?.linkedIn}
            />
            <label htmlFor="linkedIn" data-error={message.enterLinkedInUrl}>
              {message.linkedIn}
            </label>
          </div>
        </div>
      </div>
    );
  }
}

export default SocialNetwork;
